<template>
    <div>
      <div v-if="isLoading" class="loader-overlay">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>
      <div class="container-fluid">
        <div class="llp-container-section heightcontainer">
          <top-header id="height2"></top-header>
          <main-menu id="height3"></main-menu>
          <div class="menu-margin-top">
            <div class="row px-3 ml-0 justify-content-between pt-5">
              <div class="col-lg-1 col-sm-12 mt-2">
                <!-- <label class="label">Rename Role</label> -->
              </div>
              <div class="col-lg-4 col-sm-12 activitySearch mt-2 pl-0">
                <!-- <input type="text"> -->
              </div>
              <!-- <div class="col-lg-7 activityBtn mt-2" style="text-align: end"> -->
              <div class="col-lg-7 mt-2" style="text-align: end">
                <button class="btn btn-secondary mr-3" @click="updatePermissions">Save</button>
                <button class="btn btn-secondary" @click="cancel">Cancel</button>
              </div>
            </div>
            <div class="row tableContainer pb-4 px-3 ml-0 mt-5">
              <div class="col-12">
                <div class="role-form">
      <!-- Loop through permission groups -->
      <div v-for="permission in userPermissions" class="section">
        <!-- Section header with arrow icon -->
        <div class="row" >
            <div class="row col-11">
                <input  type="checkbox" v-model="permission.access" @change="toggleRowSelection(permission)" style="margin-left: 15px;" />
                <h2 >{{ permission.name }}</h2>
            </div>
          <span v-if="permission.subMenu && permission.subMenu.length" @click="toggleSection(permission)" class="col-1" :class="{'arrow-up': !permission.expanded, 'arrow-down': permission.expanded}"></span>
        </div>

        <!-- Content that will collapse/expand -->
        <transition name="slide-fade">
          <div v-if="permission.expanded" class="checkbox-group">
            <div v-for="childPerm in permission.subMenu"  class="checkbox-item">
              <input type="checkbox" :value="selectedPermission.includes(childPerm.id)" v-model="childPerm.access" @change="handleCheckboxChange($event,permission,childPerm.id,childPerm)"  />
              <label>{{ childPerm.name }}</label>
              <span v-if="childPerm.subMenu && childPerm.subMenu.length" @click="toggleSection(childPerm)" class="col-1" :class="{'arrow-up': !childPerm.expanded, 'arrow-down': childPerm.expanded}"></span>
<!-- <div class="row"> -->
  <transition name="slide-fade">
          <div v-if="childPerm.expanded" class="checkbox-group">
            <div v-for="subChildPerm in childPerm.subMenu"  class="checkbox-item">
              <input type="checkbox" :value="selectedPermission.includes(subChildPerm.id)" v-model="subChildPerm.access" @change="handleSubChildCheckbox($event,permission,childPerm,subChildPerm.id,subChildPerm)"  />
              <label>{{ subChildPerm.name }}</label>
            </div>
          </div>
        </transition>
<!-- </div> -->
            </div>
          </div>
        </transition>
      </div>
    </div>

              </div>
            </div>
          </div>
          <bottom-footer></bottom-footer>
        </div>
      </div>
    </div>
  </template>
  <script>
  import TopHeader from "@/components/TopHeader.vue";
  import MainMenu from "@/components/Menu.vue";
  import BottomFooter from "@/components/BottomFooter.vue";
  import httpcommon from "../js/http-common.js";
  import moment from "moment";
  
  export default {
    components: {
      MainMenu,
      TopHeader,
      BottomFooter,
    },
    name: "userPermissions",
  
    data() {
      return {
        isLoading: false,
        rows: 0,
        currentPage: 1,
        perPage: 10,
        isSearch: false,
        userPermissions: [],
        userId: '',
        permissions: {
        "Manage Employees": {
          expanded: true,
          perms: {
            "Add Employee": { label: "Add Employee", checked: false },
            "View/Update Employee": { label: "View/Update Employee", checked: true },
          },
        },
        "Manage Customers": {
          expanded: true,
          perms: {
            "Add Customer": { label: "Add Customer", checked: false },
            "View/Update Customer": { label: "View/Update Customer", checked: true },
          },
        },
        "Manage Sources": {
          expanded: true,
          perms: {
            "Add Dealer": { label: "Add Dealer", checked: true },
            "View/Update Dealer": { label: "View/Update Dealer", checked: true },
            "Manage Inhouse": { label: "Manage Inhouse", checked: false },
          },
        },
        "Activity Tracking": {
          expanded: true,
          perms: {
            "Schedule Activity": { label: "Schedule Activity", checked: true },
            "Manage Milege": { label: "Manage Milege", checked: true },
            "Add Task": { label: "Add Task", checked: true },
            "Update Task": { label: "Update Task", checked: true },
            "View Task": { label: "View Task", checked: true },
          },
        },
        "Performance Tracking": {
          expanded: true,
          perms: {
            "View Dashboard": { label: "View Dashboard", checked: true },
            "View Scorecard": { label: "View Scorecard", checked: true },
            "View Assignments": { label: "View Assignments", checked: true },
            "Dashboard Reporting": { label: "Dashboard Reporting", checked: true },
           
          },
        },
        "Deals Tracking": {
          expanded: true,
          perms: {
            "Generate Quote": { label: "Generate Quote", checked: true },
            "Edit Quote": { label: "Edit Quote", checked: true },
            "Add Application": { label: "Add Application", checked: true },
            "Review Application": { label: "Review Application", checked: true },
            "Convert App to Deal": { label: "Convert App to Deal", checked: true },
            "View Deals": { label: "View Deals", checked: true },
            "Yodlee": { label: "Yodlee", checked: true },
            
          },
        },"Reporting": {
          expanded: true,
          perms: {
            "Salesperson Task Notes": { label: "Salesperson Task Notes", checked: true },
            "Report an Issue": { label: "Report an Issue", checked: true },
            "Data Report": { label: "Data Report", checked: true },
            "Automated Quote Tool": { label: "Automated Quote Tool", checked: true },
            "Payoff Quote": { label: "Payoff Quote", checked: true },
            "Customer Audit History": { label: "Customer Audit History", checked: true },
            "Customer Audit History": { label: "Customer Audit History", checked: true },
          },
        },"Customer Universal Search": {
          expanded: true,
          perms: {
          },
        },"DMV Title": {
          expanded: true,
          perms: {
          },
        },"Resource": {
          expanded: true,
          perms: {
            "Release Notes": { label: "Release Notes", checked: true },
            "User Manual": { label: "User Manual", checked: true },
            "Help": { label: "Help", checked: true },
            "Contact": { label: "Contact", checked: true },
           
          },
        },
        "Role Management": {
          expanded: true,
          perms: {
            "Add Role": { label: "Add Role", checked: true },
            "Edit Role": { label: "Edit Role", checked: true },
            "Delete Role": { label: "Delete Role", checked: true },
            "Role Rename": { label: "Role Rename", checked: true },
           
          },
        },
      },
      selectedPermission: []
      };
    },
    methods: {
    getRolePermissions (userId) {
      this.isLoading = true
        httpcommon
      .get('acl/user/menu?userId='+userId)
      .then(response=>{
        this.isDeleteRole = false
        this.isLoading = false
        // this.userPermissions = response.data
        this.userPermissions = response.data.map(permission=>{
            return {
        ...permission,
        expanded : true, // Add the new property here
        subMenu: permission.subMenu.map(subMenu=>{
          return {
            ...subMenu,
            expanded : true, // Add the new property here
          }
        }) // Add the new property here
    };
    
        })
        this.userPermissions.forEach( perms => {
          if(perms.access && perms.subMenu) {
            this.selectedPermission.push(perms.id);
            perms.subMenu.forEach( sub => {
              if(sub.access) this.selectedPermission.push(sub.id)
              sub.subMenu.forEach( subSub => {
                if(subSub.access) this.selectedPermission.push(subSub.id)
              })
            })
          }
        })
      }).catch(error=>{
        this.isLoading = false
        console.log(error,'error')
      })
    },
  
      myFunction() {
        var elmnt = document.getElementById("height2");
        var elmnt1 = document.getElementById("height3");
        var txt = elmnt.offsetHeight;
        var width = elmnt.offsetWidth;
        var txt1 = elmnt1.offsetHeight;
        var ht = txt + txt1;
        $("#employee").css("margin-top", txt + txt1 + 3);
      },
      menuheight() {
        var elmnt = document.getElementById("height2");
        var txt = elmnt.offsetHeight;
        $("#height3").css("margin-top", txt);
      },
      toggleSection(permission) {
        permission.expanded = !permission.expanded;
    },
    toggleRowSelection(permission) {
        if(permission.access) {
            // if(event.target.checked) {
            
            if(!this.selectedPermission.includes(permission.id)) {
                this.selectedPermission.push(permission.id)
            }
            if(permission.subMenu) {
            permission.subMenu.forEach(element=>{
                if(!this.selectedPermission.includes(element.id)) {
                    this.selectedPermission.push(element.id)
                }
                element.access = true
                if(element.subMenu) {
                    element.subMenu.forEach(subElement=>{
                        if(!this.selectedPermission.includes(subElement.id)) {
                            this.selectedPermission.push(subElement.id)
                        }
                        subElement.access = true
                    })
                }
            })
            }
        } else {
            const parentIndex  = this.selectedPermission.indexOf(permission.id)
            if(parentIndex  !== -1) {
                this.selectedPermission.splice(parentIndex ,1)
            }
            if(permission.subMenu) {
            permission.subMenu.forEach((childPerm) => {
      const index = this.selectedPermission.indexOf(childPerm.id);
    // this.selectedPermission = this.selectedPermission.filter(id => id == childPerm.id)
      if (index !== -1) {
        this.selectedPermission.splice(index, 1)
        
      }
      childPerm.access = false
      if(childPerm.subMenu) {
        childPerm.subMenu.forEach((subChildPerm) => {
          const subChildIndex = this.selectedPermission.indexOf(subChildPerm.id);
          if (subChildIndex !== -1) {
            this.selectedPermission.splice(subChildIndex, 1)
          }
          subChildPerm.access = false
        })
      }
    
    })
  }
        }
        
    },
    handleCheckboxChange (event,permission, childId,child) {
      if (event.target.checked) {
        if (!this.selectedPermission.includes(childId)) {
            this.selectedPermission.push(childId);
            if(child.subMenu) {
                child.subMenu.forEach(element=>{
                    if(!this.selectedPermission.includes(element.id)) {
                        this.selectedPermission.push(element.id)
                    }
                    element.access = true
                })
            }
            
        }
        if (!this.selectedPermission.includes(permission.id)) {
            this.selectedPermission.push(permission.id)
            }
      } else {
        this.selectedPermission = this.selectedPermission.filter((id) => id !== childId);
        if(child.subMenu) {
          child.subMenu.forEach((subChildPerm) => {
          const subChildIndex = this.selectedPermission.indexOf(subChildPerm.id);
          if (subChildIndex !== -1) {
            this.selectedPermission.splice(subChildIndex, 1)
          }
          subChildPerm.access = false
        })
      }
        // permission.subMenu.every(element=>{
        //     if(!this.selectedPermission.includes(element.id)) {
        //         this.selectedPermission = this.selectedPermission.filter((id) => id !== permission.id);
        //         permission.access = false
        //     }
        //   })
        const allChildrenUnchecked = permission.subMenu.every(element => !this.selectedPermission.includes(element.id));
    if (allChildrenUnchecked) {
      this.selectedPermission = this.selectedPermission.filter(id => id !== permission.id);
      permission.access = false;
    }
      }
      permission.access = permission.subMenu.every((element) => this.selectedPermission.includes(element.id));
    //   if(permission.access ) {
    //     this.selectedPermission.push(permission.id)
    //   }
  
    },
    handleSubChildCheckbox (event,permission,child, subChildId,subChild) {
      if (event.target.checked) {
        if (!this.selectedPermission.includes(subChildId)) {
            this.selectedPermission.push(subChildId);
        }
        
        if (!this.selectedPermission.includes(child.id)) {
            this.selectedPermission.push(child.id)
            }
            if (!this.selectedPermission.includes(permission.id)) {
            this.selectedPermission.push(permission.id)
            }
      } else {
        this.selectedPermission = this.selectedPermission.filter((id) => id !== subChildId);
        // child.subMenu.every(element=>{
        //     if(!this.selectedPermission.includes(element.id)) {
        //         this.selectedPermission = this.selectedPermission.filter((id) => id !== child.id);
        //         child.access = false
        //     }
        //   })
        const allSubChildrenUnchecked = child.subMenu.every(element => !this.selectedPermission.includes(element.id));
    if (allSubChildrenUnchecked) {
      this.selectedPermission = this.selectedPermission.filter(id => id !== child.id);
      child.access = false;
    }
      }
      child.access = child.subMenu.some((element) => this.selectedPermission.includes(element.id));
    //   if(permission.access ) {
    //     this.selectedPermission.push(permission.id)
    //   }
  
    },
     updatePermissions () {
        const permissions = []
        this.selectedPermission.forEach(id=>{
            permissions.push({menuId:id})
        })
        this.isLoading = true
        httpcommon
      .put('/acl/user/update?userId='+this.userId,permissions)
      .then(response=>{
        this.$router.push('/userManagement')
        this.isLoading = false
        // this.userPermissions = response.data
      }).catch(error=>{
        this.isLoading = false
        console.log(error,'error')
      })
},
cancel () {
    this.$router.push('/userManagement')
},
updateMainPermission() {
      this.userPermissions.forEach(permission => {
        if (permission.subMenu.length) {
          permission.access = permission.subMenu.every(child => this.selectedPermission.includes(child.id));
        }
      });
    }
    
    },
    watch: {
    selectedPermission: {
      handler() {
        this.updateMainPermission();
      },
      deep: true
    }
  },
    created() {
      window.addEventListener("resize", this.myFunction);
      window.addEventListener("resize", this.menuheight);
    },
    mounted() {
      this.myFunction();
      this.menuheight();
      this.userId = this.$route.params.userId
      this.getRolePermissions(this.userId)
    },
  };
  </script>
  <style scoped>
  .label {
    color: #6E8399;
    font-weight: 600;
    font-size: 16px;
  }
  .activitySearch input {
  font: 400;
  font-size: 16px;
  color: #1c1b1f;
  border: 1px solid #e4ecf4;
  border-radius: 8px;
  padding: 10px;
  height: 44px;
  width: 100%;
}
.activityBtn button {
  border-radius: 8px;
  color: #ffffff;
  font-weight: 600;
  font-size: 18px;
  background-color: #1e90ff;
  padding: 10px;
  height: 44px;
  width: 160px;
  border: none;
  /* width: 100%; */
}
 .containerA {
  width: 100%;
  margin: 0 auto;
  padding: 20px;
  /* background-color: #f7f7f7; */
}

/* .header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
} */

/* input[type="text"] {
  font-size: 16px;
  padding: 5px;
  width: 60%;
} */

/* button {
  padding: 8px 16px;
  background-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 5px;
} */

.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loader {
  border: 12px solid #f3f3f3;
  border-top: 12px solid #3498db;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 2s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.role-form {
  column-count: 3;
  column-gap: 16px;
  row-gap: 23px;
}

.section {
    break-inside: avoid; /* Prevent items from breaking between columns */
    padding: 16px; /* Padding for items */
    border: 1px solid #ccc; /* Border for items */
    margin-bottom: 13px;
    border-radius: 8px;
  /* overflow: hidden; */
}

.section-header {
  display: flex;
  /* justify-content: space-around; */
  align-items: center;
  cursor: pointer;
}

h2 {
  font-size: 18px;
}

.arrow-down::before {
  content: "▼";
  cursor: pointer;
}

.arrow-up::before {
  content: "▲";
  cursor: pointer;
}

.checkbox-group {
  margin-top: 10px;
  /* Control the height dynamically based on content */
  max-height: 400px;
  transition: all 0.3s ease;
  margin-left: 25px;
}

.checkbox-item {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

input[type="checkbox"] {
  margin-right: 10px;
  cursor: pointer;
}

label {
  font-size: 14px;
}

/* Add transitions for smooth collapse/expand */
.slide-fade-enter-active, .slide-fade-leave-active {
  transition: max-height 0.3s ease;
}

.slide-fade-enter, .slide-fade-leave-to {
  max-height: 0;
  opacity: 0;
 }
</style>